import React from 'react';
import ContentLayout from '../../../components/ContentLayout';
import props from '../../../lib/contentLayoutProps/admissions/layoutProps';

/* eslint-disable react/prop-types */
export default () => (
  <ContentLayout {...props} locale="en" pageKey="school-tour">
    <h1>School Tour</h1>
    <p>
      Every few weeks (the first Wednesday of each month), we welcome interested families to join us for a tour of our
      campuses, led by members of our school leadership team.
    </p>
    <p>Please call 2337 9031 or email us at enquiry@kingston.edu.hk to book your tour.</p>
  </ContentLayout>
);
